export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.27036fd9a8ac60a9e99c6ef45531c0a2.css";